const btnLoaders = document.querySelectorAll('.button-loader');

if (btnLoaders.length > 0) {
  const groups = new Set();

  gsap.utils.toArray('.button-loader').forEach((loader) => {
    const parent = loader.closest('[data-button-loader-parent]');
    groups.add(parent || loader);
  });

  groups.forEach((group) => {
    const loaders = group.matches('[data-button-loader-parent]')
      ? [...group.querySelectorAll('.button-loader')]
      : [group];

    const items = loaders.flatMap((loader) => [...loader.querySelectorAll('.button-loader__images img')]);

    gsap.set(items, {
      transformOrigin: '50% 100%',
    });

    const tl = gsap.timeline({
      repeat: -1,
    });

    items.forEach((item, index) => {
      tl.to(
        item,
        {
          keyframes: [
            {
              y: -8,
              scaleY: 1.22,
              scaleX: 0.88,
              duration: 0.22,
              ease: 'power2.out',
            },
            {
              y: 0,
              scaleY: 0.78,
              scaleX: 1.22,
              duration: 0.24,
              ease: 'power2.in',
            },
            {
              scaleY: 1.08,
              scaleX: 0.95,
              duration: 0.12,
              ease: 'power1.out',
            },
            {
              scaleY: 0.97,
              scaleX: 1.03,
              duration: 0.08,
              ease: 'power1.inOut',
            },
            {
              scaleY: 1,
              scaleX: 1,
              duration: 0.18,
              ease: 'elastic.out(1.2, 0.45)',
            },
          ],
        },
        index * 0.08,
      );
    });

    tl.timeScale(0.9);

    // Pause/resume
    const targets = group.matches('[data-button-loader-parent]') ? loaders : [group];

    const update = () => {
      const shouldPause = targets.every((loader) => loader.classList.contains('hide'));

      if (shouldPause) {
        tl.pause();
      } else {
        tl.resume();
      }
    };

    update();

    targets.forEach((loader) => {
      new MutationObserver(update).observe(loader, {
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  });
}
